export type SetupParams = {
  MicrositeName: string;
  ThemeId: number;
  ChannelCode: string | null;
  Hostname: string;
  EmbedId: string;
};

export default class SetupParamsHelper {
  /**
   * Get SetupParams from the query string in the javascript file's URL
   * @returns A SetupParams object containing the MicrositeName, ThemeId, ChannelCode, Hostname, and EmbedId
   */
  static getSetupParams = (): SetupParams => {
    // The current implementation works when script has type="module". It's unlikely that we'll need to support non-module scripts in the future.
    // But in case we need to, we could try-catching the error and using document.currentScript?.getAttribute("src").

    // Docs on import.meta https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/import.meta
    const url = new URL(import.meta.url);

    let embedId = url.searchParams.get("EmbedId");
    if (!(embedId && document.getElementById(embedId))) {
      embedId = document.getElementById("root") ? "root" : null;
    }
    if (!embedId) {
      throw new Error(
        "Couldn't find an element where to embed the widget. Ensure the EmbedId parameter is correct."
      );
    }

    const themeId = parseInt(url.searchParams.get("ThemeId") || "", 10);
    if (isNaN(themeId)) {
      throw new Error("Missing ThemeId parameter");
    }

    const micrositeName = url.searchParams.get("MicrositeName");
    if (!micrositeName) {
      throw new Error("Missing MicrositeName parameter");
    }

    const hostname = url.host;
    if (!hostname) {
      throw new Error("Missing Hostname parameter");
    }

    const channelCode = url.searchParams.get("ChannelCode");
    return {
      MicrositeName: micrositeName,
      ThemeId: themeId,
      ChannelCode: channelCode,
      Hostname: hostname,
      EmbedId: embedId,
    };
  };
}
